export default __webpack_public_path__ + "static/media/work-ethic.1c092ba7.webp";